import { CommonContexts, IModal, UuiContexts } from '@epam/uui-core'
import { showSuccessNotification } from '../notifications/showSuccessNotification'
import { showModalWindow } from '../common/commonModalComponent/showModalWindow'
import { MESSAGES } from '../../constants/messages'
import { IBasicModalWindowModalProps } from '../common/commonModalComponent/BasicModalWindow'
import React from 'react'
import { Button } from '@epam/loveship'

export const showDeletePointIsNotPossibleModal = (
  svc: CommonContexts<UuiContexts, any>
) => {
  const messages = {
    title: MESSAGES.POINT_DELETE_IS_NOT_POSSIBLE_MODAL.TITLE,
    description: MESSAGES.POINT_DELETE_IS_NOT_POSSIBLE_MODAL.DESCRIPTION,
    action: MESSAGES.POINT_DELETE_IS_NOT_POSSIBLE_MODAL.ACTION,
  }

  const buttons = [
    (
      modalProps: IModal<string> & IBasicModalWindowModalProps,
      key: number | string
    ): React.ReactNode => (
      <Button
        color="sky"
        caption="Close"
        onClick={() => modalProps && modalProps.abort()}
        key={key}
      />
    ),
  ]

  return showModalWindow(svc, messages, undefined, buttons).then((result) =>
    showSuccessNotification({ svc, message: result })
  )
}
